/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlPlatform } from './ControlPlatform';
import {
    ControlPlatformFromJSON,
    ControlPlatformFromJSONTyped,
    ControlPlatformToJSON,
} from './ControlPlatform';

/**
 * 
 * @export
 * @interface ControlDirectoryUserIntegrationCount
 */
export interface ControlDirectoryUserIntegrationCount {
    /**
     * 
     * @type {number}
     * @memberof ControlDirectoryUserIntegrationCount
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUserIntegrationCount
     */
    integrationId: string;
    /**
     * 
     * @type {ControlPlatform}
     * @memberof ControlDirectoryUserIntegrationCount
     */
    platform: ControlPlatform;
}

/**
 * Check if a given object implements the ControlDirectoryUserIntegrationCount interface.
 */
export function instanceOfControlDirectoryUserIntegrationCount(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "integrationId" in value;
    isInstance = isInstance && "platform" in value;

    return isInstance;
}

export function ControlDirectoryUserIntegrationCountFromJSON(json: any): ControlDirectoryUserIntegrationCount {
    return ControlDirectoryUserIntegrationCountFromJSONTyped(json, false);
}

export function ControlDirectoryUserIntegrationCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDirectoryUserIntegrationCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'integrationId': json['integrationId'],
        'platform': ControlPlatformFromJSON(json['platform']),
    };
}

export function ControlDirectoryUserIntegrationCountToJSON(value?: ControlDirectoryUserIntegrationCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'integrationId': value.integrationId,
        'platform': ControlPlatformToJSON(value.platform),
    };
}

